var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.996,
    height: 60.004,
    viewBox: "0 0 54.996 60.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29734",
    "data-name": "Group 29734",
    transform: "translate(-1115.502 -497.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_282",
    "data-name": "Subtraction 282",
    d: "M33.017,60H7.5A7.51,7.51,0,0,1,0,52.5v-45A7.5,7.5,0,0,1,7.5,0H27.744l.009,0,.007,0,.023.012h.007a.163.163,0,0,1,.077.012H27.9a.344.344,0,0,0,.1.011.018.018,0,0,0,.019.011,2.518,2.518,0,0,1,1.256.684l15,15.006A2.463,2.463,0,0,1,45,17.628V33.373c-.368-.026-.741-.04-1.116-.04a15.412,15.412,0,0,0-9.169,3A2.512,2.512,0,0,0,32.492,35H12.5a2.5,2.5,0,1,0,0,5H31.126a15.526,15.526,0,0,0,1.889,20ZM12.5,25a2.5,2.5,0,1,0,0,5H32.492a2.5,2.5,0,1,0,0-5Zm0-9.989a2.5,2.5,0,1,0,0,5H17.5a2.5,2.5,0,1,0,0-5ZM30,8.523h0v3.968a2.505,2.505,0,0,0,2.489,2.517H36.46L30,8.524Z",
    transform: "translate(1115.502 497.348)",
    fill: "#1d0b77",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_281",
    "data-name": "Subtraction 281",
    d: "M11.1,22.222A11.111,11.111,0,1,1,22.219,11.113,11.119,11.119,0,0,1,11.1,22.222Zm0-12.916a.771.771,0,0,0-.771.771v6.206a.776.776,0,0,0,1.552,0V10.077A.776.776,0,0,0,11.1,9.306Zm0-3.363a1.032,1.032,0,1,0,1.036,1.035A1.033,1.033,0,0,0,11.1,5.943Z",
    transform: "translate(1148.279 535.127)",
    fill: "#1d0b77",
    opacity: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/Group-icon.aac4e9bc1384abaa800ffb3dbeab3cb9.svg";
export { ForwardRef as ReactComponent };